// extracted by mini-css-extract-plugin
module.exports = {"content":"kUnRgWQBc7C_WK1fGwC7","invoices":"ewfn1wgogJ9NRARD13Re","projects":"gdOQ5hIjoltmU2j8K5uZ","icon":"NslwFtFr4eXRG41uFuCc"};